import { SvgIcon } from "@material-ui/core";

export const AirportIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M6.85005 17.15L3.65005 15.4L4.70005 14.35L7.20005 14.7L11.1 10.8L3.30005 6.55005L4.70005 5.15005L14.25 7.60005L18.175 3.72505C18.4584 3.44172 18.8126 3.30005 19.2375 3.30005C19.6625 3.30005 20.0167 3.44172 20.3001 3.72505C20.5834 4.00838 20.725 4.36255 20.725 4.78755C20.725 5.21255 20.5834 5.56672 20.3001 5.85005L16.4001 9.75005L18.85 19.3L17.4501 20.7L13.2 12.9L9.30005 16.8L9.65005 19.3L8.60005 20.35L6.85005 17.15Z"
        fill={props.fill || "currentColor"}
      />
    </SvgIcon>
  );
};
